__turbopack_context__.v({
  "errorIcon": "error-module-scss-module__QjrYYq__errorIcon",
  "errorSnackbar": "error-module-scss-module__QjrYYq__errorSnackbar",
  "errorSnackbarDesktop": "error-module-scss-module__QjrYYq__errorSnackbarDesktop",
  "warningIcon": "error-module-scss-module__QjrYYq__warningIcon",
});
